<template>
  <div id="help">
    <!--<div class="trader-ban">
      <img src="../assets/img/about2.jpg">
    </div>-->
    <div class="content">
      <!--<div class="new_guide">
        <div class="newPerson">新手指引</div>
        <div class="border"></div>
      </div>-->
      <div class="container-w">
        <div class="page-inner box-shadow">
          <el-row :gutter="30">
            <el-col :span="6">
              <ul class="nav nav-page-menu flex-column">
                <li class="nav-item">
                  <router-link to="/help/helpabout" class="nav-link">
                    <i class="el-icon-s-home"></i>
                    <span>关于我们</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/help/helpguidelines" class="nav-link">
                    <i class="el-icon-s-order"></i>
                    <span>新手指引</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/help/helpguide" class="nav-link">
                    <i class="el-icon-reading"></i>
                    <span>配资指南</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/help/helprules" class="nav-link">
                    <i class="el-icon-collection-tag"></i>
                    <span>交易规则</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/help/helpagreement" class="nav-link">
                    <i class="el-icon-edit"></i>
                    <span>注册协议</span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/help/helpqualification" class="nav-link">
                    <i class="el-icon-s-finance"></i>
                    <span>公司资质</span>
                  </router-link>
                </li>
                <!--<li class="nav-item">
                  <router-link to="/help/helpoffice" class="nav-link">
                    <i class="el-icon-office-building"></i>
                    <span>办公环境</span>
                  </router-link>
                </li>-->
                <li class="nav-item">
                  <router-link to="/help/helpcontact" class="nav-link">
                    <i class="el-icon-s-custom"></i>
                    <span>联系我们</span>
                  </router-link>
                </li>
                <!--<li class="nav-item">
                  <router-link to="/help/helpapp" class="nav-link">
                    <i class="el-icon-download"></i>
                    <span>APP下载</span>
                  </router-link>
                </li>-->
                <li class="nav-item">
                  <router-link to="/help/helpcenter" class="nav-link">
                    <i class="el-icon-s-help"></i>
                    <span>帮助中心</span>
                  </router-link>
                </li>
                <!--<li class="nav-item">
                  <router-link to="/help/helpstatement" class="nav-link">
                    <i class="el-icon-notebook-2"></i>
                    <span>法律保障</span>
                  </router-link>
                </li>-->
                <!--<li class="nav-item">
                    <a class="nav-link " href="/portal/page/index/id/30.html">
                        <i class="fa fa-cog"></i>
                        <span>苹果交易端</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " href="/portal/page/index/id/31.html">
                        <i class="fa fa-flag"></i>
                        <span>安卓交易端</span>
                    </a>
                </li>-->

              </ul>
            </el-col>
            <el-col :span="18">
              <router-view />
            </el-col>
          </el-row>
        </div>
      </div>
     <!-- <div class="paganition">
        <router-link
          class="page"
          v-for="(item,index) in list"
          :key="index"
          :to="{name:'Helpdetails',params:{id:item.id}}"
          active-class="Active"
        >
          <div class="page_img">
            <img src="../assets/img/helpCenter_tu1.png">
          </div>
          <div class="pageDes">
            <div>{{item.title}}</div>
            <div class="description" v-html="item.content"></div>
            <el-button>{{item.time}}</el-button>
            &lt;!&ndash; <button>{{item.time}}</button> &ndash;&gt;
          </div>
        </router-link>
      </div>-->
    </div>
  </div>
</template>
<script>

import $ from "jquery";
// import func from './vue-temp/vue-editor-bridge';
export default {
  name: "Help",
  components: {
  },
  data() {
    return {
      list: []
    };
  },
  mounted: function() {
    // $("#wrapper").css("background", "#737373");
    $("body,html").css({ overflow: "inherit", height: "100%" });
    // let that = this;
    // that
    //   .$http({
    //     url: "/app/Help/help_center",
    //     method: "post",
    //     data: {
          
    //     }
    //   })
    //   .then(function(res) {
    //     if (res.data.code == 1) {
    //       if (res.data.data.length) {
    //         that.list = res.data.data;
    //         setTimeout(function(){
    //           $(".description").html(
    //           $(".description")
    //             .text()
    //             .replace(/\s*/g, "")
    //             .substring(0, 120)+"..."
    //         );
    //         },300)

    //       }
    //     } else if (res.data.code == 0 || res.data.code == -1) {
    //       that.$message.error(that.$t(res.data.msgId));
    //     }
    //   });
  },
  methods: {}
};
</script>
<style scoped>
/*@import url("./../assets/css/help.css");*/
@import url("./../assets/css/style.css");
.content{
  padding-bottom: 100px;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-link {
  display: block;
  padding: .5rem 1rem;
}
</style>





// WEBPACK FOOTER //
// src/components/help.vue